import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const saveDynamicTemplate = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/save-template`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getDynamicTemplateList = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/filter`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getFavDynamicTemplateList = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/favorites`
    );
    return response.data;
  } catch (e) {
    if (e.message !== "No Refresh Token") {
      console.error(e);
    }
  }
};

export const getFavDynamicTemplateCount = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/favorite-count`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const makeFavoriteDynamicTemplate = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/make-fav`,
        data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};


export const getDynamicTemplateById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getItemChargeInfo = async(dyhId, itemId) => {
  try{
    const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/item/details/${dyhId}/${itemId}`);
    return response.data
  }catch (e) {
    console.error(e);
  }
}

export const getCommonDropdownValues = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/common-dropdown`
    );
    return response?.data?.map((item) => ({
      key: item.dcmId,
      text: item.dcmName,
      value: JSON.stringify({
        dcmId: item.dcmId,
        dcmName: item.dcmName,
      }),
    }));
  } catch (e) {
    console.error(e);
  }
};

export const updateDynamicTemplate = async (updateData) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-template/update-template`,
        updateData
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

// export const getCategories = async () => {
//   try {
//     const response = await gatewayInstance.get(
//       `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-templates/categories`
//     );
//     return response.data?.map((item) => ({
//       key: item.dyhCategory,
//       value: item.dyhCategory,
//       text: item.dyhCategoryName,
//     }));
//   } catch (e) {
//     console.error(e);
//   }
// };

// export const getInspectionTypesByCategory = async (dyhCategory) => {
//   try {
//     const response = await gatewayInstance.get(
//       `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-templates/inspection-types/${dyhCategory}`
//     );
//     return response.data?.map((item) => ({
//       key: item.dyhInspectionType,
//       value: item.dyhInspectionType,
//       text: item.dyhInspectionTypeName,
//     }));
//   } catch (e) {
//     console.error(e);
//   }
// };

// export const getInspectionTypes = async () => {
//   try {
//     const response = await gatewayInstance.get(
//       `${SERVICE_ENDPOINT.TRANSPORT}/dynamic-templates/management-types`
//     );
//     return response.data?.map((item) => ({
//       key: item.keyId,
//       text: item.keyValue1,
//       value: item.keyId,
//     }));
//   } catch (e) {
//     console.error(e);
//   }
// };


export const getDynamicReportTypes = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/report-types/dynamic`
    );
    return response?.data?.map((item) => ({
      key: item.dyrId,
      text: item.dyrReport,
      value: item.dyrId,
    }));
  } catch (e) {
    console.error(e);
  }
};
